var _g, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupportBackgroundGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 124,
    viewBox: "0 0 328 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3263_63900)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 328,
    height: 124,
    rx: 8,
    fill: "#E5FBED"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.455 55.558L221.678 42.3474V42.3385C218.885 41.459 217.36 38.5361 218.264 35.8176L221.514 26.0718C222.418 23.3533 225.421 21.8696 228.215 22.7492L269.991 35.9598C276.199 37.9231 281.358 31.0113 277.523 25.8764L258.207 0H284.373L294.65 13.7674C298.484 18.9024 306.829 16.2638 306.829 9.9206V0H320C324.418 0 328 3.58172 328 8V116C328 120.418 324.418 124 320 124H306.829V113.642C306.829 107.299 298.484 104.66 294.65 109.795L284.046 124H257.88L277.523 97.6862C281.348 92.5512 276.19 85.6394 269.991 87.6028L228.215 100.813C225.421 101.702 222.418 100.209 221.514 97.4907L218.264 87.7538C218.086 87.2239 218.001 86.6862 218 86.1574C218 86.1523 218 86.1471 218 86.142C218.003 83.9639 219.434 81.9393 221.678 81.2329L263.455 68.0223C269.654 66.0589 269.654 57.5214 263.455 55.558Z",
    fill: "#F6FEF9"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 327,
    height: 123,
    rx: 7.5,
    stroke: "#E5FBED"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3263_63900"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 328,
    height: 124,
    rx: 8,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportBackgroundGreen);
export default __webpack_public_path__ + "static/media/support-background-green.04306ecfe39bb9f5082858bb3fd1f4a8.svg";
export { ForwardRef as ReactComponent };